<template>
  <div id="Sign-Up">
    <b-container>
      <b-row>
        <b-col sm="7" class="d-none d-sm-block">
          &nbsp;
        </b-col>
        <b-col sm="12" md="5" id="right-content" class="d-flex align-items-center">
          <div id="form-wrapper">
            <h1>Sign In</h1>
            <b-form id="login-form" @keydown.enter.prevent="LOG_IN(credentials)">
              <span id="invalidCreds" v-if="apiErrors.LOG_IN">Invalid Email or Password</span>
              <span id="resetMessage" v-if="showResetMessage">You will receive an email with instructions on how to reset your password in a few minutes.</span>
              <b-form-group class="inputField">
                <div class="input-wrapper">
                  <b-form-input
                    id="email"
                    name="email"
                    v-model="$v.credentials.user.email.$model"
                    :state="validateState('email')"
                  />
                  <label for="user">Email</label>
                  <b-form-invalid-feedback
                    v-if="!$v.credentials.user.email.required"
                    class="login-error"
                  >
                    Email is required
                  </b-form-invalid-feedback>

                  <b-form-invalid-feedback
                    id="inputLiveFeedback"
                    v-if="!$v.credentials.user.email.email"
                    class="login-error"
                  >
                    Insert a valid Email
                  </b-form-invalid-feedback>
                </div>
              </b-form-group>

              <div class="input-wrapper">
                <b-form-input
                  v-model="credentials.user.password"
                  :type="showPassword ? 'text' : 'password'"
                />
                <label for="user">Password</label>
                <b-form-invalid-feedback
                  v-if="!$v.credentials.user.password.required"
                >
                  Password is required
                </b-form-invalid-feedback>
                <ShowPassword
                  id="showPassword"
                  @click="showPassword = !showPassword"
                />
              </div>
              <label for="checkbox" id="remember-me">
                <input id="checkbox" type="checkbox"/>
                Remember me
              </label>

              <div class="text-center mt-0 mb-5">
                <router-link id="forgot-pass" :to="{ name: 'ForgotPassword' }">
                  Forgot your password?
                </router-link>
              </div>
      
              <div class="text-center">
                <button
                    @click.prevent="LOG_IN(credentials)"
                    :disabled="$v.credentials.user.$invalid"
                    id="login-button"
                  >
                  LOG IN
                </button>
              </div>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength, sameAs, email } from "vuelidate/lib/validators";
import { mapActions, mapState } from "vuex";
import ShowPassword from "@/components/common/ShowPassword";

export default {
  components: { ShowPassword },
  mixins: [validationMixin],
  data() {
    return {
      credentials: {
        user: {
          email: null,
          password: null,
        },
      },
      showPassword: false,
      subscriptionMessages: {
        admin: "Your Subscription is no longer active. Please select a new plan / update credit card info to continue using TorchMetrics.",
        member: "Your Organization's Subscription is no longer active. Please contact your Group Manager/Org Admin asking for renewal to continue using TorchMetrics."
      },
    };
  },
  validations: {
    credentials: {
      user: {
        email: {
          required,
          email,
        },
        password: {
          required,
        },
      },
    },
  },

  computed: {
    ...mapState(["apiErrors", "currentUser", "showResetMessage"]),
  },
  methods: {
    ...mapActions(["LOG_IN", "CLEAR_API_LOGIN_ERRORS", "CLEAR_RESET_MESSAGE_FLAG"]),

    validateState(name) {
      const { $dirty, $error } = this.$v.credentials.user[name];
      return $dirty ? !$error : null;
    },
    isExpirationDateValid() {
      return new Date(this.currentUser.expiration_date) >= new Date();
    },
    isSubscriptionDateValid() {
      return new Date(this.currentUser.subscription_end_date) >= new Date();
    },
    isOrgMember() {
      return !this.currentUser.admin && ["group_member", "group_manager"].includes(this.currentUser.kind);
    },
    displaySubscriptionErrorMessage(){
        let msg = this.isOrgMember() ? this.subscriptionMessages.member : this.subscriptionMessages.admin;
        alert(msg);
    }
  },
  watch: {
    currentUser() {
      if(this.currentUser.plan_status === 'expired' || !this.isExpirationDateValid()) this.displaySubscriptionErrorMessage();
      if (this.currentUser.is_subscription && !this.isSubscriptionDateValid()) this.displaySubscriptionErrorMessage();

      if (this.currentUser.admin == true) {
        this.$router.push({ name: "AdminGroups" });
      } else {
        this.$router.push({ name: "UserDashboard" });
      }
    },
  },
  mounted() {
    this.CLEAR_API_LOGIN_ERRORS();
  },
  beforeDestroy(){
    this.CLEAR_RESET_MESSAGE_FLAG();
  }
};
</script>

<style lang="less" >
@import "../../assets/components/signIn/signIn.less";
@import "../../assets/components/common/FormInput.less";
</style>